import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mismatch-user',
  imports: [],
  templateUrl: './mismatch-user.component.html',
  styleUrl: './mismatch-user.component.scss'
})
export class MismatchUserComponent implements OnInit{
  isLoggedIn = false; 
  currentUser:any
  maskedPhone = '98*******86';
  maskedEmail = 'jai****40@**.com';

  constructor(private _AS : AuthService,private router: Router){}

  ngOnInit(): void {
    this.currentUser = this._AS.getUser()
    console.log(this.currentUser)
    this.maskedPhone = this.maskPhone(this.currentUser.data.phone);
    this.maskedEmail = this.maskEmail(this.currentUser.data.email)
    
  }

  switchAccount() {
    this._AS.logout();
    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl: '/sharedPro/view/Rajnikant test/827f1706-3ab1-4aee-b44c-83fbe4b911a4'
      }
    });
  }

  goToLogin() {
    // navigate to login page
  }

  requestAccess() {
    // open modal OR call API
  }
  maskPhone(phone: string): string {
    if (!phone || phone.length < 4) return phone;
    return phone.slice(0, 2) + '*'.repeat(phone.length - 4) + phone.slice(-2);
  }
  
  maskEmail(email: string): string {
    if (!email || !email.includes('@')) return email;
    const [local, domain] = email.split('@');
    const [domainName, ...tlds] = domain.split('.');
  
    const maskedLocal = local.slice(0, 3) + '*'.repeat(Math.max(local.length - 3, 2));
    const maskedDomain = '*'.repeat(Math.max(domainName.length - 1, 2));
  
    return `${maskedLocal}@${maskedDomain}.${tlds.join('.')}`;
  }
}
